import {
  Alert,
  AlertIcon,
  Box,
  chakra,
  GridItem,
  Heading,
  Icon,
  Link,
  Text,
} from '@chakra-ui/react'
import NextLink from 'next/link'
import { FaCheckCircle } from 'react-icons/fa'
import { ICheckToken } from 'services/guest.service'
import AutoinspectorLink from './AutoinspectorLink'

function RegisterInfo(props: {
  invitation?: ICheckToken
  buildHref: () => string
}) {
  return (
    <GridItem pl={[0, 0, 16]} pt={[0, 0, 16]} colSpan={{ md: 6 }}>
      <Box
        w={['100%', '100%', '80%']}
        mb='8'
        display='flex'
        justifyContent='flex-start'
        pl='4'
      >
        <AutoinspectorLink />
      </Box>
      <Box mt='8' px={[1, 1]}>
        {!!props.invitation && (
          <Alert mb={4} status='info' borderRadius='md'>
            <AlertIcon />
            <Box fontSize='xs'>
              <Text>
                Fuiste invitado para ser parte de{' '}
                <chakra.span fontWeight='bold'>
                  {props.invitation?.companyName}
                </chakra.span>
              </Text>
            </Box>
          </Alert>
        )}
        <Box display={{ base: 'none', md: 'initial' }}>
          <Box mb='8'>
            <Heading fontSize='md' display='flex' alignItems='center'>
              <Icon as={FaCheckCircle} color='landingPrimary' mr='4' />
              Empieza de inmediato
            </Heading>
            <Text pl='8' fontSize='sm'>
              Integra Autoinspector mediante nuestra API o a través de
              soluciones prediseñadas con pocas líneas de código.
            </Text>
          </Box>
          <Box mb='8'>
            <Heading fontSize='md' display='flex' alignItems='center'>
              <Icon as={FaCheckCircle} color='landingPrimary' mr='4' />
              Inspecciones al instante
            </Heading>
            <Text pl='8' fontSize='sm'>
              Comienza a utilizar Autoinspector en el mismo momento que
              contratas el servicio mediante nuestra plataforma.
            </Text>
          </Box>
          <Box>
            <Heading fontSize='md' display='flex' alignItems='center'>
              <Icon as={FaCheckCircle} color='landingPrimary' mr='4' />
              Únete a la revolución del modelo Insurtech
            </Heading>
            <Text pl='8' fontSize='sm'>
              Autoinspector es elegido por startups y empresas que buscan
              innovar y automatizar procesos.
            </Text>
          </Box>
        </Box>
        <Text
          display={['none', 'none', 'block']}
          textAlign='center'
          fontSize='sm'
          mt='40'
        >
          ¿Ya tienes una cuenta?{' '}
          <Link href={props.buildHref()} as={NextLink} fontWeight='bold'>
            Inicia sesión
          </Link>
        </Text>
      </Box>
    </GridItem>
  )
}

export default RegisterInfo
